import React from 'react';

import { NavbarBrand } from 'reactstrap';

import style from './SmartConsentLogo.module.scss';

export default function SmartConsentLogo() {
  return (
    <NavbarBrand href="/" className={style.logo}>
      <img
        alt="Smart Consent Logo"
        src="/images/ts-smartconsent.png"
        srcSet="/images/ts-smartconsent.png 1x, /images/ts-smartconsent@2x.png 2x, /images/ts-smartconsent@3x.png 3x"
      />
    </NavbarBrand>
  );
}
